import Backbone from 'backbone';
import $ from 'jquery';

import CreateOligoModal from 'molbio/oligos/CreateOligoModal';
import {openImportOligoModal} from 'nav/CreateDropdownActions';
import runModal from 'ui-library/runModal';
import ifCreateFromHash from 'util/ifCreateFromHash';

class CreateImportOligoView extends Backbone.View<Backbone.Model> {
  handleCreate(): void {
    function callback(): void {
      runModal(CreateOligoModal, {});
    }

    $(document).on('click', '.js-create-new-oligo', (e) => {
      e.preventDefault();
      callback();
    });
    const {hash} = window.location;
    if (hash.indexOf('#create/oligo') === 0) {
      callback();
      window.location.hash = '';
    }
  }

  handleImport(): void {
    function callback(): void {
      openImportOligoModal(null);
    }
    ifCreateFromHash('#import-oligo', callback);
  }

  render(): this {
    this.handleCreate();
    this.handleImport();
    return this;
  }
}

export default CreateImportOligoView;
